<template>
  <footer>
    <a href="/">
      <img
        class="footer-logo"
        src="https://api.slater.co.nz/v/2f9a8bcc-b51f-4a18-be2f-3626fee11460.svg"
      />
    </a>

    <div class="footer-content">
      <div class="footer-row">
        <div class="footer-col">
          <div class="footer-heading">About Slater</div>
          <a href="/partners" class="footer-link">Partners</a>
          <a href="/testimonials" class="footer-link mt-20">Testimonials</a>
        </div>

        <div class="footer-col">
          <div class="footer-heading">Contact</div>
          <a href="tel:078389700" class="footer-link">07 838 9700</a>
          <a href="/contact" class="footer-link mt-20">Email us</a>
        </div>

        <div class="footer-col">
          <div class="footer-heading">How we can help</div>
          <a href="/pricing" class="footer-link mt-20">Pricing</a>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-copy">
          <div>© {{ new Date().getFullYear() }} Slater Charted Accountants Limited.</div>
          <div class="footer-terms">
            <a href="/terms" class="footer-link">Privacy & Terms</a>
          </div>
        </div>

        <div class="social-links">
          <a
            href="https://www.facebook.com/slaternz/"
            target="_blank"
            class="social-item footer-link"
            >Facebook</a
          >
          <a href="https://twitter.com/SlatersNZ/" target="_blank" class="social-item footer-link"
            >Twitter</a
          >
          <a
            href="https://www.instagram.com/slater_chartered_accountants/"
            target="_blank"
            class="social-item footer-link"
            >Instagram</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup></script>

<style scoped>
/* Footer Base */
footer {
  display: flex;
  flex-direction: column;
  padding: 0 150px 60px;
  margin-top: 50px;
}

/* Logo */
.footer-logo {
  width: 48px;
  height: 48px;
}

/* Footer Content */
.footer-content {
  display: flex;
  flex-direction: column;
}

/* Footer Columns */
.footer-row {
  display: flex;
  margin-top: 50px;
  padding-bottom: 83px;
}

.footer-col {
  display: flex;
  flex-direction: column;
  width: 25vw;
}

/* Footer Text */
.footer-heading {
  margin-bottom: 20px;
  color: rgb(33, 59, 85);
}

.footer-link {
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-color: #13b5ea;
  font-weight: 600;
  font-size: 21px;
}

.mt-20 {
  margin-top: 20px;
}

/* Footer Bottom */
.footer-bottom {
  display: flex;
  padding-top: 43px;
  border-top: 1px solid #d6dade;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-copy {
  display: flex;
  flex-direction: column;
  width: 30vw;
  color: rgb(33, 59, 85);
  font-size: 15px;
}

.footer-terms {
  display: flex;
  margin-top: 40px;
}

/* Social Links */
.social-links {
  display: flex;
  width: 30vw;
  justify-content: space-around;
  margin-left: 20vw;
  margin-top: 20px;
}

.social-item {
  margin-left: 20px;
}

/* Responsive */
@media only screen and (max-width: 768px) {
  footer {
    padding: 0 20px 60px;
  }

  .footer-col {
    width: 100%;
    margin-top: 30px;
  }

  .social-links {
    flex-direction: column;
    margin-top: 0;
  }

  .social-item {
    margin-left: 0;
  }
}

@media only screen and (max-width: 480px) {
  .footer-row {
    flex-direction: column;
  }

  .footer-col {
    width: 100%;
    margin-top: 30px;
  }
}
</style>
